<h1 class="page-title">Issues of the Horizons Newsletter</h1>
<div *ngIf="!isInactive">
  <div class="item-list">
    <div class="item" *ngFor="let item of horizonsList">
      <h3 class="heading--4">
        <a style="cursor: pointer;" (click)="retrievePDFFile(item.id)">{{item.fileName}}</a>
      </h3>
      <div class="data-list data-list--inline ">
        <div class="data-item data-item--inline ">
          <div class="data-item__label label">File Size</div>
          <div class="data-item__value">{{item.size | fileSize}}</div>
        </div>
        <div class="data-item data-item--inline ">
          <div class="data-item__label label">Publish Date</div>
          <div class="data-item__value">{{item.publishDate | amDateFormat: 'll'}}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isInactive">
  <h2 class="error-message">It looks like your status is inactive.</h2>
  <p><a routerLink="/purchase/annual-renewal">Click here</a> to activate your status to view this content.</p>
  <p>Your active status gives you access to the directory of active credentialed practitioners, the Horizons Newsletter and reduced prices on products.</p>
</div>
